// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xMVN","controls":"styles_controls__2SDFa","charLimit":"styles_charLimit__1YaNJ","input":"styles_input__1Y9kZ","send":"styles_send__15wtb"};